import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {

    LOADSTATS = 'react/common/stats/LOADSTATS',
    LOADSTATS_PENDING = 'react/common/stats/LOADSTATS_PENDING',
    LOADSTATS_FULFILLED = 'react/common/stats/LOADSTATS_FULFILLED',
    LOADSTATS_REJECTED = 'react/common/stats/LOADSTATS_REJECTED',
    
    OTHER_ACTION = 'react/common/posts/__any_other_action__',
}

export type Types = IBaseAction<Keys>;